<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="100"
            :has-details-row="true"
            :selectable-rows="false"
          >
            <template #row-details="row">
              <quantity-scale-details-row :row="row" />
            </template>
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(groupKz)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.groupKz"
                input-type="number"
              />
            </template>
            <template #head(group)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.group"
                input-type="number"
              />
            </template>
            <template #head(priceList)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.priceList"
                input-type="number"
              />
            </template>
            <template #head(articleId)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleId" />
            </template>
            <template #head(zuAbArt)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.zuAbArt"
                input-type="number"
              />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.primaryKey" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import {NotificationMixin, ArticleMixin} from '../../../mixins';
import QuantityScaleDetailsRow from './quantity-scale-details-row';
import PageHeader from '../../structure/page-header';
import TableFilter from '../../table/table-filter';

const fiveElements = Array.from({ length: 5 }, (_, i) => i + 1);

export default {
  name: 'QuantityScale',
  components: {PageHeader, QuantityScaleDetailsRow, DataTable, TableFilter},
  mixins: [NotificationMixin, ArticleMixin],
  data: function () {
    return {
      table: {
        rows: [],
        fields: [
          {key: 'check', label: '', tdClass: 'check', thClass: 'check'},
          {key: 'company', label: this.$translate('company')},
          {key: 'groupKz', label: `${this.$translate('group')} Kz`},
          {key: 'group', label: this.$translate('group')},
          {key: 'priceList', label: this.$translate('price_list')},
          {key: 'articleId', label: this.$translate('article')},
          {key: 'zuAbArt', label: this.$translate('zu_ab_art')},
          {key: 'mengenStaffelArt', label: this.$translate('mengen_staffel_art')},
          ...fiveElements.map(i => ({
            key: `fromQuantity${i}`, label: `${this.$translate('from_quantity')} ${i}`
          })),
          ...fiveElements.map(i => ({
            key: `toDiscount${i}`, label: `${this.$translate('to_discount')} ${i}`
          })),
          {key: 'primaryKey', label: this.$translate('primary_key')},
        ],
        filter: {
          company: null,
          groupKz: null,
          group: null,
          priceList: null,
          articleId: null,
          zuAbArt: null,
          primaryKey: null,
        }
      }
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getQuantityScalePage(ctx);
        return {totalCount: response.totalCount, data: response.data};
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    }
  }
};
</script>

<style scoped lang="scss">
    // @media (max-width: 991px) {
    //     .main-content {
    //         max-height: calc(100vh - 100px);
    //     }
    // }

    ::v-deep   .table {
        min-width: 1000px;

        th, td {
            &.check {
                width: 3%;
            }
        }
    }
</style>
